export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const formatRelative = (value: string | null | undefined): string => {
  if (!value) return "Never";
  const date = new Date(value);
  const ms = Date.now() - date.getTime();
  if (Number.isNaN(ms)) return "—";
  const minutes = Math.round(ms / 60000);
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  return formatDateTime(value);
};

export const parseApiError = (error: unknown, fallback: string): string => {
  if (!(error instanceof Error) || !error.message) return fallback;
  try {
    const parsed = JSON.parse(error.message) as { message?: string };
    return parsed?.message || fallback;
  } catch {
    return error.message || fallback;
  }
};

/** Message from a rejected Signal Administration thunk (a string), or
 * `fallback`. */
export const errorText = (error: unknown, fallback: string): string =>
  typeof error === "string" && error ? error : parseApiError(error, fallback);
